/**
 * Il messaggio di un errore del backend, sempre come FRASE.
 *
 * Un 422 di validazione di FastAPI ha `detail` = elenco di oggetti: passato così
 * a React fa cadere la pagina (in produzione, pagina bianca). Qui diventa testo.
 *
 * All'unione dei rami del 24-09 ne è rimasta una sola: `messaggioErrore` di
 * `lib/preventivi.js`, che dice il campo in italiano invece del messaggio
 * inglese di pydantic. `messaggioDi` resta come nome per chi lo usa già.
 */
import { messaggioErrore } from "./preventivi";

export function messaggioDi(e) {
  return messaggioErrore(e, "Qualcosa non ha funzionato");
}
